export default __webpack_public_path__ + "static/media/Mark-5-HUD-Artificial Horizon.c7a00fdf.jpg";